import { apiClient } from './client'

export type DefaultProfilePicture = {
  id: string
  name: string
  imageUrl: string
  objectKey: string
  sortOrder: number
  isActive: boolean
  createdAt: string
  updatedAt: string
  updatedBy?: string | null
}

export type UpdateDefaultProfilePictureRequest = {
  name?: string | null
  sortOrder?: number | null
  isActive?: boolean | null
}

export async function getDefaultProfilePictures(params?: { activeOnly?: boolean }): Promise<DefaultProfilePicture[]> {
  const { data } = await apiClient.get<DefaultProfilePicture[]>('/api/admin/default-profile-pictures', {
    params
  })
  return data
}

export async function createDefaultProfilePicture(
  file: File,
  options?: { name?: string | null; sortOrder?: number | null; isActive?: boolean }
): Promise<DefaultProfilePicture> {
  const formData = new FormData()
  formData.append('file', file)

  const { data } = await apiClient.post<DefaultProfilePicture>(
    '/api/admin/default-profile-pictures',
    formData,
    {
      params: {
        name: options?.name || undefined,
        sortOrder: options?.sortOrder ?? undefined,
        isActive: options?.isActive ?? true
      }
    }
  )
  return data
}

export async function updateDefaultProfilePicture(
  id: string,
  payload: UpdateDefaultProfilePictureRequest
): Promise<DefaultProfilePicture> {
  const { data } = await apiClient.put<DefaultProfilePicture>(
    `/api/admin/default-profile-pictures/${encodeURIComponent(id)}`,
    payload
  )
  return data
}

export async function replaceDefaultProfilePictureImage(id: string, file: File): Promise<DefaultProfilePicture> {
  const formData = new FormData()
  formData.append('file', file)

  const { data } = await apiClient.post<DefaultProfilePicture>(
    `/api/admin/default-profile-pictures/${encodeURIComponent(id)}/image`,
    formData
  )
  return data
}
